<template>
  <dx-data-grid
    ref="dataGridRef"
    :allow-column-reordering="true"
    :column-chooser="{ enabled: true, mode: 'select' }"
    :column-min-width="150"
    :columns="columns"
    :data-source="dataSource"
    :filter-panel="{ visible: true }"
    :filter-row="{ visible: true }"
    :header-filter="{ visible: true }"
    :height="50"
    :hover-state-enabled="true"
    :remote-operations="true"
    :row-alternation-enabled="true"
    :show-borders="true"
    :show-column-lines="true"
    :width="'100%'"
    :word-wrap-enabled="true"
    style="flex-grow: 1"
    @toolbar-preparing="onToolbarPreparing($event)"
    @selection-changed="selectionChanged($event)"
    @content-ready="onContentReady($event)"
  >
    <dx-paging :enabled="true" :page-size="30" />
    <dx-load-panel :enabled="true" />
    <dx-scrolling mode="virtual" />
    <dx-sorting mode="single" />
    <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />
    <dx-selection
      :mode="selectionMode"
    />

  </dx-data-grid>

  <footer-grid :totalCount="totalCount" class="px-2"></footer-grid>

</template>

<script>
export default {
  name: 'mped-amortization-main-asset-view',
};
</script>

<script setup>
import { ref, defineProps, onMounted } from 'vue';
import {
  DxDataGrid,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxExport,
  DxPaging,
  DxSelection,
} from 'devextreme-vue/data-grid';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';
import {
  getMainAsset,
} from '@/views/mped/services/mped-amortization-api-service';
import {
  columnsAmortizationMainAsset,
} from '@/views/mped/services/mped-calculation-service';
import { initState, setLocalUserdata } from '@/service/local-userdata-service';
import { useRouter } from 'vue-router';

const
  totalCount = ref(0),
  columns = columnsAmortizationMainAsset,
  dataGridRef = ref(),
  router = useRouter();

let
  selectedRowsData = [],
  toolbarButtons = {};

const dataSource = getAiDataSource(
  {
    dataFn: getMainAsset,
    key: 'id',
    remoteOperation: true,
    validationFn: () => {
      return true;
    },
    onLoadedFn: (data) => {
      totalCount.value = data.totalCount;
    },
    defaultDescSort: false,
    columns
  },
);

const { chooseItem, selectionMode } = defineProps({
  chooseItem: {
    type: Boolean,
    default: false,
  },
  selectionMode: {
    type: String,
    default: 'single',
  },
});

const emit = defineEmits(['selectedItem']);

onMounted(async () => {
  if (chooseItem) return;

  initState(router, dataGridRef);
});

const onToolbarPreparing = (e) => {
  toolbarButtons = getAiToolbar(e, {
    refresh: {
      event: reloadData,
    },
    ...(chooseItem && { check: { event: selectedItems } } || {}),
  });
};

const reloadData = () => {
  dataSource.reload();
};

const selectedItems = (e) => {
  emit('selectedItem', selectionMode === 'single' && selectedRowsData[0] || selectedRowsData);
};

const selectionChanged = (e) => {
  selectedRowsData = e.selectedRowsData;
  if (toolbarButtons.check)
    toolbarButtons.check.option({ disabled: !selectedRowsData.length });
};

const onContentReady = (e) => {
 if (chooseItem) return;

  setLocalUserdata(router, dataGridRef);
}

</script>

<style scoped>

</style>
